import React from 'react';

const NotificationSettings = ({ 
  notificationSettings, 
  templates, 
  loadingTemplates,
  hasNotificationChanges,
  savingNotificationSettings,
  onNotificationToggle,
  onTemplateSelect,
  onLoadTemplates,
  onSaveSettings,
  onShowMacroModal,
  onShowExampleModal
}) => {
  const getToggleValue = (value, fallback = false) =>
    typeof value === 'boolean' ? value : fallback;

  return (
    <div style={{ padding: "20px", borderBottom: "1px solid #EBEBEB" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "nowrap" }}>
        <div style={{ flex: "1", minWidth: "0" }}>
          <h4 style={{ marginBottom: "8px", color: "#333", whiteSpace: "nowrap" }}>알림톡 설정</h4>
          <p style={{ fontSize: "14px", color: "#666", margin: "0", lineHeight: "1.4" }}>
            지필 과제 생성 및 채점 완료 시 자동으로 알림톡을 발송할 수 있습니다.
          </p>
        </div>
        <div style={{ display: "flex", gap: "8px", flexShrink: 0, marginLeft: "20px", flexWrap: "wrap" }}>
          <button
            onClick={onLoadTemplates}
            disabled={loadingTemplates}
            style={{
              padding: "8px 14px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: "5px",
              backgroundColor: loadingTemplates ? "#ccc" : "#17a2b8",
              border: "none",
              color: "#FFF",
              cursor: loadingTemplates ? "not-allowed" : "pointer",
              transition: "background-color 0.2s",
              whiteSpace: "nowrap"
            }}
            onMouseOver={(e) => {
              if (!loadingTemplates) e.target.style.backgroundColor = "#138496";
            }}
            onMouseOut={(e) => {
              if (!loadingTemplates) e.target.style.backgroundColor = "#17a2b8";
            }}
          >
            {loadingTemplates ? "동기화 중..." : "센드온과 동기화"}
          </button>
          <button
            onClick={onSaveSettings}
            disabled={!hasNotificationChanges || savingNotificationSettings}
            style={{
              padding: "8px 14px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: "5px",
              backgroundColor: hasNotificationChanges && !savingNotificationSettings ? "#007bff" : "#ccc",
              border: "none",
              color: "#FFF",
              cursor: hasNotificationChanges && !savingNotificationSettings ? "pointer" : "not-allowed",
              transition: "background-color 0.2s",
              whiteSpace: "nowrap"
            }}
            onMouseOver={(e) => {
              if (hasNotificationChanges && !savingNotificationSettings) {
                e.target.style.backgroundColor = "#0056b3";
              }
            }}
            onMouseOut={(e) => {
              if (hasNotificationChanges && !savingNotificationSettings) {
                e.target.style.backgroundColor = "#007bff";
              }
            }}
          >
            {savingNotificationSettings ? "저장 중..." : "설정 저장"}
          </button>
          <button
            onClick={onShowMacroModal}
            style={{
              padding: "8px 14px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: "5px",
              backgroundColor: "#6f42c1",
              border: "none",
              color: "#FFF",
              cursor: "pointer",
              transition: "background-color 0.2s",
              whiteSpace: "nowrap"
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = "#5a2d91"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#6f42c1"}
          >
            매크로 안내
          </button>
          <button
            onClick={onShowExampleModal}
            style={{
              padding: "8px 14px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: "5px",
              backgroundColor: "#fd7e14",
              border: "none",
              color: "#FFF",
              cursor: "pointer",
              transition: "background-color 0.2s",
              whiteSpace: "nowrap"
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = "#e8650e"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#fd7e14"}
          >
            예시 템플릿
          </button>
        </div>
      </div>
      
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "20px" }}>
        {/* 알림장 발송 시 알림 */}
        <div style={{
          padding: "16px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fafafa"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                알림장 발송 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                알림장 발송 버튼 클릭 시 항상 알림톡이 발송됩니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <input
                type="checkbox"
                id="class-notice-toggle"
                checked={notificationSettings.classNoticeEnabled}
                onChange={() => onNotificationToggle('classNoticeEnabled')}
                style={{ display: "none" }}
              />
              <label
                htmlFor="class-notice-toggle"
                style={{
                  display: "block",
                  width: "48px",
                  height: "28px",
                  background: notificationSettings.classNoticeEnabled ? "#007bff" : "#ddd",
                  borderRadius: "14px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  position: "relative"
                }}
              >
                <span style={{
                  position: "absolute",
                  top: "2px",
                  left: notificationSettings.classNoticeEnabled ? "22px" : "2px",
                  width: "24px",
                  height: "24px",
                  background: "white",
                  borderRadius: "12px",
                  transition: "all 0.3s",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                }}></span>
              </label>
            </div>
          </div>

          {notificationSettings.classNoticeEnabled && (
            <>
              <div style={{ marginTop: "12px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  사용할 템플릿 선택
                </label>
                <select
                  value={notificationSettings.classNoticeTemplate}
                  onChange={(e) => onTemplateSelect('classNoticeTemplate', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">템플릿을 선택해주세요</option>
                  {templates.map(template => (
                    <option
                      key={template.id}
                      value={template.sendon_template_id || template.id}
                      disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                    >
                      {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' :
                       template.status === 'DRAFT' ? '작성중' :
                       template.status === 'PENDING' ? '검수대기' :
                       template.status === 'IN_REVIEW' ? '검수중' :
                       template.status || '알 수 없음'})
                    </option>
                  ))}
                </select>
                {loadingTemplates && (
                  <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                    템플릿 목록을 불러오는 중...
                  </p>
                )}
                {!loadingTemplates && templates.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#e74c3c", marginTop: "4px" }}>
                    사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                  </p>
                )}
              </div>

              {/* 수신자 선택 */}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'classNoticeSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 알림장 알림이 발송됩니다.',
                  defaultValue: false,
                  activeColor: '#17a2b8'
                }, {
                  field: 'classNoticeSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 알림장 알림이 발송됩니다.',
                  defaultValue: true,
                  activeColor: '#28a745'
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        border: "1px solid #e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <div style={{ position: "relative", flexShrink: 0 }}>
                        <input
                          type="checkbox"
                          id={`class-notice-recipient-${idx}`}
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor={`class-notice-recipient-${idx}`}
                          style={{
                            display: "block",
                            width: "48px",
                            height: "28px",
                            background: isActive ? option.activeColor : "#ddd",
                            borderRadius: "14px",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            position: "relative"
                          }}
                        >
                          <span style={{
                            position: "absolute",
                            top: "2px",
                            left: isActive ? "22px" : "2px",
                            width: "24px",
                            height: "24px",
                            background: "white",
                            borderRadius: "12px",
                            transition: "all 0.3s",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                          }}></span>
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* 과제 배정 시 알림 (새 섹션) */}
        <div style={{
          padding: "16px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fafafa"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                과제 배정 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                과제가 있는 알림장 발송 시 추가로 알림톡이 발송됩니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <input
                type="checkbox"
                id="homework-assigned-toggle"
                checked={notificationSettings.homeworkAssignedEnabled}
                onChange={() => onNotificationToggle('homeworkAssignedEnabled')}
                style={{ display: "none" }}
              />
              <label
                htmlFor="homework-assigned-toggle"
                style={{
                  display: "block",
                  width: "48px",
                  height: "28px",
                  background: notificationSettings.homeworkAssignedEnabled ? "#007bff" : "#ddd",
                  borderRadius: "14px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  position: "relative"
                }}
              >
                <span style={{
                  position: "absolute",
                  top: "2px",
                  left: notificationSettings.homeworkAssignedEnabled ? "22px" : "2px",
                  width: "24px",
                  height: "24px",
                  background: "white",
                  borderRadius: "12px",
                  transition: "all 0.3s",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                }}></span>
              </label>
            </div>
          </div>

          {notificationSettings.homeworkAssignedEnabled && (
            <>
              <div style={{ marginTop: "12px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  사용할 템플릿 선택
                </label>
                <select
                  value={notificationSettings.homeworkAssignedTemplate}
                  onChange={(e) => onTemplateSelect('homeworkAssignedTemplate', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">템플릿을 선택해주세요</option>
                  {templates.map(template => (
                    <option
                      key={template.id}
                      value={template.sendon_template_id || template.id}
                      disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                    >
                      {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' :
                       template.status === 'DRAFT' ? '작성중' :
                       template.status === 'PENDING' ? '검수대기' :
                       template.status === 'IN_REVIEW' ? '검수중' :
                       template.status || '알 수 없음'})
                    </option>
                  ))}
                </select>
                {loadingTemplates && (
                  <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                    템플릿 목록을 불러오는 중...
                  </p>
                )}
                {!loadingTemplates && templates.length === 0 && (
                  <p style={{ fontSize: "12px", color: "#e74c3c", marginTop: "4px" }}>
                    사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                  </p>
                )}
              </div>

              {/* 수신자 선택 */}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'homeworkAssignedSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 과제 배정 알림이 발송됩니다.',
                  defaultValue: false,
                  activeColor: '#17a2b8'
                }, {
                  field: 'homeworkAssignedSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 과제 배정 알림이 발송됩니다.',
                  defaultValue: true,
                  activeColor: '#28a745'
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        border: "1px solid #e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <div style={{ position: "relative", flexShrink: 0 }}>
                        <input
                          type="checkbox"
                          id={`homework-assigned-recipient-${idx}`}
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor={`homework-assigned-recipient-${idx}`}
                          style={{
                            display: "block",
                            width: "48px",
                            height: "28px",
                            background: isActive ? option.activeColor : "#ddd",
                            borderRadius: "14px",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            position: "relative"
                          }}
                        >
                          <span style={{
                            position: "absolute",
                            top: "2px",
                            left: isActive ? "22px" : "2px",
                            width: "24px",
                            height: "24px",
                            background: "white",
                            borderRadius: "12px",
                            transition: "all 0.3s",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                          }}></span>
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* 채점 완료 시 알림 */}
        <div style={{
          padding: "16px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fafafa"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
            <div style={{ flex: 1, marginRight: "10px" }}>
              <h5 style={{ margin: "0 0 4px 0", fontSize: "16px", color: "#333" }}>
                지필 과제 채점 완료 시 알림
              </h5>
              <p style={{ margin: "0", fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                지필 과제 채점이 완료될 때 선택한 대상에게 알림을 발송합니다.
              </p>
            </div>
            <div style={{ position: "relative", flexShrink: 0 }}>
              <input
                type="checkbox"
                id="grading-completed-toggle"
                checked={notificationSettings.gradingCompletedEnabled}
                onChange={() => onNotificationToggle('gradingCompletedEnabled')}
                style={{ display: "none" }}
              />
              <label 
                htmlFor="grading-completed-toggle" 
                style={{
                  display: "block",
                  width: "48px",
                  height: "28px",
                  background: notificationSettings.gradingCompletedEnabled ? "#007bff" : "#ddd",
                  borderRadius: "14px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  position: "relative"
                }}
              >
                <span style={{
                  position: "absolute",
                  top: "2px",
                  left: notificationSettings.gradingCompletedEnabled ? "22px" : "2px",
                  width: "24px",
                  height: "24px",
                  background: "white",
                  borderRadius: "12px",
                  transition: "all 0.3s",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                }}></span>
              </label>
            </div>
          </div>
          
          {notificationSettings.gradingCompletedEnabled && (
            <div style={{ marginTop: "12px" }}>
              <label style={{ 
                display: "block", 
                marginBottom: "8px", 
                fontSize: "14px", 
                fontWeight: "600", 
                color: "#333" 
              }}>
                사용할 템플릿 선택
              </label>
              <select
                value={notificationSettings.gradingCompletedTemplate}
                onChange={(e) => onTemplateSelect('gradingCompletedTemplate', e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "14px",
                  backgroundColor: "white"
                }}
              >
                <option value="">템플릿을 선택해주세요</option>
                {templates.map(template => (
                  <option 
                    key={template.id} 
                    value={template.sendon_template_id || template.id}
                    disabled={template.status !== 'APPROVED' && template.status !== 'approved'}
                  >
                    {template.template_name} ({template.status === 'APPROVED' || template.status === 'approved' ? '승인완료' : 
                     template.status === 'DRAFT' ? '작성중' :
                     template.status === 'PENDING' ? '검수대기' :
                     template.status === 'IN_REVIEW' ? '검수중' : 
                     template.status || '알 수 없음'})
                  </option>
                ))}
              </select>
              {loadingTemplates && (
                <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                  템플릿 목록을 불러오는 중...
                </p>
              )}
              {!loadingTemplates && templates.length === 0 && (
                <p style={{ fontSize: "12px", color: "#e74c3c", marginTop: "4px" }}>
                  사용 가능한 템플릿이 없습니다. 센드온과 동기화 버튼을 눌러주세요.
                </p>
              )}
              <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                {[{
                  field: 'gradingCompletedSendToStudent',
                  label: '학생에게 알림톡 보내기',
                  description: '활성화 시 학생에게 채점 완료 알림이 발송됩니다.',
                  defaultValue: false,
                  activeColor: '#17a2b8'
                }, {
                  field: 'gradingCompletedSendToParent',
                  label: '학부모에게 알림톡 보내기',
                  description: '활성화 시 학부모에게 채점 완료 알림이 발송됩니다.',
                  defaultValue: true,
                  activeColor: '#28a745'
                }].map((option, idx) => {
                  const isActive = getToggleValue(notificationSettings[option.field], option.defaultValue);
                  return (
                    <div
                      key={option.field}
                      style={{
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        border: "1px solid #e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px"
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <label style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          {option.label}
                        </label>
                        <p style={{
                          fontSize: "12px",
                          color: "#666",
                          margin: "0",
                          lineHeight: "1.4"
                        }}>
                          {option.description}
                        </p>
                      </div>
                      <div style={{ position: "relative", flexShrink: 0 }}>
                        <input
                          type="checkbox"
                          id={`grading-recipient-${idx}`}
                          checked={isActive}
                          onChange={() => onNotificationToggle(option.field)}
                          style={{ display: "none" }}
                        />
                        <label
                          htmlFor={`grading-recipient-${idx}`}
                          style={{
                            display: "block",
                            width: "48px",
                            height: "28px",
                            background: isActive ? option.activeColor : "#ddd",
                            borderRadius: "14px",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            position: "relative"
                          }}
                        >
                          <span style={{
                            position: "absolute",
                            top: "2px",
                            left: isActive ? "22px" : "2px",
                            width: "24px",
                            height: "24px",
                            background: "white",
                            borderRadius: "12px",
                            transition: "all 0.3s",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                          }}></span>
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div style={{ 
        marginTop: "16px", 
        padding: "12px", 
        backgroundColor: "#fff3cd", 
        border: "1px solid #ffeaa7", 
        borderRadius: "6px" 
      }}>
        <p style={{ margin: "0", fontSize: "13px", color: "#856404" }}>
          💡 <strong>참고:</strong> 알림톡 템플릿은 '알림톡 관리' 탭에서 생성하고 관리할 수 있습니다. 
          승인된 템플릿만 선택 가능합니다.
        </p>
      </div>
    </div>
  );
};

export default NotificationSettings;
